export default function getGlobalVariable(){

    const globalVariables = {mainUrl :"https://api-v2.agsports.app", encryptKey : "ek_live_koD2fMokM1EPu8aSmdn1Z6YVs0hHu6"}

    return globalVariables
}